/**
 * Status of ONE signer of the SEPA mandate signing process anchored on a
 * {@code cr.CustomerBankAccount}, in cr's own vocabulary.
 * <p>
 * Mirrors {@code com.mvs.backend.cr.enums.CrSepaMandateSignerStatusEnum}. The ordinals are
 * deliberately IDENTICAL to that backend enum (which is itself ordinal-aligned with
 * {@code sm.enums.SmSignerStatusEnum}) — never reorder, only append.
 */
export enum CrSepaMandateSignerStatusEnum {
    pending,
    readyForSign,
    signed,
    sentForExternal,
    externallySigned,
    declined,
    expired,
    skipped,
    unassigned
}
